import React, {useState} from 'react'
import DeviceOnlineRate from './device-online-rate'
import DeviceRegionDistribute from './device-region-distribute'
import EnergyConsumption from './energy-consumption'
import DeviceWarningInfomation from './device-warning-infomation'
import GroupManagement from './group-management'
import EnergyBlock from './energy-block'
import './index.less'

export default function CockpitEnergyStatistics() {
  return (
    <div className="energy-block">
      <EnergyBlock />
      <div className="energy-statistic-block">
        <div className="energy-block-left">
          <DeviceOnlineRate />
          <DeviceRegionDistribute />
        </div>
        <div className="energy-block-mid">
          <GroupManagement />
        </div>
        <div className="energy-block-right">
          <EnergyConsumption />
          <DeviceWarningInfomation />
        </div>
      </div>
    </div>
  )
}
